

import Panel from 'vux/src/components/panel/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import Calendar from '@/components/calendar/index'
import { getAppointmentList } from '@/api/index.js'
import { Message } from 'element-ui'
export default {
name: 'Index',
components: {
Panel,
Calendar,
Icon,
Flexbox,
FlexboxItem,
Datetime,
Toast,
Message,
Spinner
},
data () {
return {

AllData: [],

officeName: [],


amFold: true,
pmFold: false,
appDate: '',
showSpin: false,
showImage: false
}
},
filters: {
timeTransform: function (time) {
console.log(time)
let d = new Date(time.replace(/-/g, '/'))
return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} ${d.getHours()}:${d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()}`
}
},
watch: {
appDate (value, oldvalue) {
if (value !== oldvalue) {
this.AllData = []
this.officeName = []
this.loadData()
}
}
},
methods: {
async loadData () {
this.showSpin = true
this.showImage = false
const params = {
docId: this.$route.query.id,
appDate: {
appDate: this.appDate
}
}
try {
const responese = await getAppointmentList(params)
if (responese) {
console.log('返回的数据为', responese)

this.officeName = Object.keys(responese[0])
this.AllData = responese[0]

Object.keys(this.AllData).forEach((item, index) => {
this.$set(this.AllData[item], 'Fold1', true)
this.$set(this.AllData[item], 'Fold0', true)
})
this.showSpin = false
} else {
this.showImage = true
}
} catch (error) {
this.showSpin = false
this.showImage = true
}
},
itemClick (model) {
this.$router.push({ name: 'detail', query: { emrId: model.emrId, appDate: this.appDate, idNo: model.idNo } })
},
amFoldClick (item) {

item.Fold1 = !item.Fold1
},
pmFoldClick (item) {
item.Fold0 = !item.Fold0
},
pickdate (date) {
this.appDate = date
}
}

}



// WEBPACK FOOTER //
// ./src/views/Index.vue